import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    const icons = {
      lead: 'UserPlus',
      referral: 'Users',
      commission: 'DollarSign',
      sale: 'TrendingUp',
      points: 'Award'
    };
    return icons?.[type] || 'Bell';
  };

  const getActivityColor = (type) => {
    const colors = {
      lead: 'var(--color-accent)',
      referral: 'var(--color-primary)',
      commission: 'var(--color-success)',
      sale: 'var(--color-secondary)',
      points: '#D97706'
    };
    return colors?.[type] || 'var(--color-muted)';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('es-PE', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleTimeString('es-PE', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading">
          Actividad Reciente
        </h3>
        <Icon name="Activity" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-4 max-h-96 overflow-auto">
        {activities?.map((activity) => (
          <div 
            key={activity?.id} 
            className="flex items-start space-x-4 p-4 rounded-xl hover:bg-muted transition-smooth"
          >
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}
            >
              <Icon 
                name={getActivityIcon(activity?.type)} 
                size={20} 
                color={getActivityColor(activity?.type)}
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">
                {activity?.title}
              </p>
              <p className="text-sm text-muted-foreground line-clamp-2">
                {activity?.description}
              </p>
              <div className="flex items-center space-x-3 mt-2">
                <span className="text-xs text-muted-foreground data-text">
                  {formatDate(activity?.timestamp)}
                </span>
                <span className="text-xs text-muted-foreground">•</span>
                <span className="text-xs text-muted-foreground data-text">
                  {formatTime(activity?.timestamp)}
                </span>
              </div>
            </div>

            {activity?.amount && (
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-semibold text-success data-text">
                  +S/ {activity?.amount?.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;